/**
 * Prüfungstexte als HTML **zeigen**, ohne fremdem HTML zu trauen (Vorgabe des Nutzers,
 * 2026-10-02: „HTML soll, wenn vorhanden, auch angezeigt werden“).
 *
 * Antworttexte, Kriterien und Vignetten kommen aus Relay und Classic als HTML aus einem Editor.
 * Bis dahin wurde alles zu Klartext (`htmlText.ts`); Hervorhebungen wie „von *dorsal*“ gingen
 * verloren, und Relays Texte standen sogar mit ihren Tags im Bogen.
 *
 * **Eine Erlaubnisliste, keine Sperrliste.** Durch kommen nur Tags, die Text auszeichnen, und
 * **kein einziges Attribut**: kein `style`, kein `href`, kein `on…`. Damit gibt es nichts, was
 * ausführt oder nachlädt — und auch kein `color:black`, das im dunklen Erscheinungsbild
 * unsichtbar wäre.
 *
 * ⚠️ **Reine Zeichenkettenarbeit, kein `DOMParser`.** So läuft es ohne DOM in den Tests und
 * gleich auf iOS 15. Das genügt, weil nichts von der Eingabe in ein Tag gelangt ausser dem
 * Namen, und der muss auf der Liste stehen.
 */

const ERLAUBT = new Set([
  'p', 'br', 'b', 'strong', 'i', 'em', 'u', 's', 'sub', 'sup',
  'ul', 'ol', 'li', 'span', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
]);

/** Fallen samt Inhalt weg. */
const MIT_INHALT_WEG = /<(script|style|template|noscript|textarea|title)\b[\s\S]*?<\/\1\s*>/gi;

const TAG = /<\/?([a-zA-Z][a-zA-Z0-9]*)\b[^>]*>/g;

/** Ein `&`, das keine Entität beginnt, und lose spitze Klammern werden zu Entitäten. */
const schuetzeText = (text: string) =>
  text
    .replace(/&(?!#\d+;|#x[0-9a-fA-F]+;|[a-zA-Z][a-zA-Z0-9]*;)/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

export function bereinigeHtml(html: string): string {
  const ohne = html.replace(/<!--[\s\S]*?-->/g, '').replace(MIT_INHALT_WEG, '');
  let aus = '';
  let rest = 0;
  for (const treffer of ohne.matchAll(TAG)) {
    aus += schuetzeText(ohne.slice(rest, treffer.index));
    rest = treffer.index + treffer[0].length;
    const name = treffer[1].toLowerCase();
    if (!ERLAUBT.has(name)) continue;
    const schliessend = treffer[0].startsWith('</');
    if (name === 'br') {
      // `</br>` ist kein Tag, das es gibt; es fällt weg.
      if (!schliessend) aus += '<br>';
      continue;
    }
    aus += schliessend ? '</' + name + '>' : '<' + name + '>';
  }
  return aus + schuetzeText(ohne.slice(rest));
}

/** Trägt der Text Auszeichnung oder Entitäten — lohnt sich also das HTML? */
export const hatMarkup = (text: string): boolean =>
  /<\/?[a-zA-Z][^>]*>|&(#\d+|#x[0-9a-fA-F]+|[a-zA-Z][a-zA-Z0-9]*);/.test(text);
